//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableServer from '../../../../components/Table/Table.vue'
import TableCellObject from '../../../../components/Table/TableCellObject.vue'
import { getStockControlJournalRecordColumns, showStockControlDialog, showStockControlDispatcherRecordDialog, openStockControlRecordView, getStoredSelectedDepartmentId } from './StockControl.js'
import { EventBus } from '../../../../EventBus/EventBus.js'
import { axiosGet } from '../../../../axios/axios.js'

export default {
  name: 'StockControlJournal',
  components: {
    TableServer,
    TableCellObject
  },
  props: {
    stockId: {
      type: Number,
      default: null
    },
    formId: {
      type: String,
      default: null
    },
    defaultDepartmentId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      departmentSelectorConfig: {
        loading: false,
        // defaultDepartmentId: this.defaultDepartmentId,
        departmentId: null,
        department: null,
        departments: [],
        hasChanges: false
      },

      baseUrl: '/service/delta/stock/control/record/list',
      additionalUrlParams: this.getAdditionalUrlParams(),
      updateEvent: 'update-stockControlRecord',
      filterType: 'stockControlRecord',
      autoUpdateTimeout: 300000,
      itemMapper: null,

      columns: this.getColumns(),
      loading: false,
      tableLoading: false
    }
  },
  computed: {
    hasEditAccess: function () {
      return this.$d_hasOperation('stockAccessoryControl')
    },
    hasControlPerformAccess: function () {
      return this.hasEditAccess
    },
    hasSendEmailNotificationAccess: function () {
      const user = this.$store.getters.getUser
      return user.login === 'ymaxim'
    },
    loadingCommon: function () {
      return this.loading || this.tableLoading
    }
  },
  watch: {
    'departmentSelectorConfig.departmentId': function (id) {
      this.additionalUrlParams = this.getAdditionalUrlParams()
    },
    loadingCommon: function (value) {
      this.$emit('loading-change', value)
    }
  },
  mounted: function () {
    EventBus.$on(this.updateEvent, this.onUpdateEvent)
  },
  beforeDestroy: function () {
    EventBus.$off(this.updateEvent, this.onUpdateEvent)
  },
  methods: {
    /**
     * Может вызываться извне
     */
    onUpdate: function () {
      const tableComponent = this.$refs.table
      if (tableComponent) {
        tableComponent.onUpdate()
      }
    },
    onTableLoadingChange: function (value) {
      this.tableLoading = value
    },

    getColumns: function () {
      const stockControlRecordColumns = getStockControlJournalRecordColumns()
      return this.prepareColumns(stockControlRecordColumns)
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
      }
      return columns
    },

    getAdditionalUrlParams: function () {
      const params = {}
      params.stockId = this.stockId
      if (this.departmentSelectorConfig && this.departmentSelectorConfig.departmentId != null) {
        params.depId = this.departmentSelectorConfig.departmentId
      }
      return params
    },

    onUpdateEvent: function (event) {
      if (event && event.target != this) {
        // TODO
      }
    },

    onOpenControlRecord: function (record, $event) {
      if ($event && $event.ctrlKey) {
        openStockControlRecordView({
          stockControlRecordId: record.id,
          stockControlRecordType: record.type,
          formId: this.formId,
          readonly: false,
          onRecordSaved: null,
          mobile: false,
          target: this
        })
      } else {
        showStockControlDispatcherRecordDialog({
          stockControlRecordId: record.id,
          stockControlRecordType: record.type,
          formId: this.formId,
          readonly: false,
          onRecordSaved: null,
          mobile: false,
          target: this
        })
      }
    },
    onPerformControl: function () {
      let departmentId = this.departmentSelectorConfig.departmentId || this.departmentSelectorConfig.defaultDepartmentId || null
      if (departmentId == null) {
        const user = this.$store.getters.getUser
        departmentId = getStoredSelectedDepartmentId(user)
      }

      showStockControlDialog({
        // stockControlRecordId: null,
        // stockControlRecordType: 'stockControlPresenceCheckJournalRecord',
        stockId: this.stockId,
        depId: departmentId,
        formId: this.formId,
        readonly: false,
        onRecordSaved: null,
        mobile: false,
        target: this
      })
    },
    onSendEmailNotification: function () {
      const urlParams = new URLSearchParams()
      urlParams.set('stockId', this.stockId)

      const depId = this.departmentSelectorConfig.departmentId || this.departmentSelectorConfig.defaultDepartmentId
      if (depId) {
        urlParams.set('depId', depId)
      }
      urlParams.set('filter', 'stockControlRecord')
      urlParams.set('formId', this.formId)

      return axiosGet({
        url: 'service/delta/stock/control/record/listSendEmail?' + urlParams.toString(),
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Отчёт отправлен на почту',
            progress: true,
            timeout: 4000
          })
        },
        onFailure: 'Ошибка отправки отчёта на почту'
      })
    },

    getTrStyle: function (record) {
      if (record.type === 'stockControlPresenceCheckJournalRecord') {
        if (record.skipped) {
          return 'background-color: #e3f2fd;' // bg-blue-1
        } else if (record.presentCount != null && record.totalCount != null) {
          if (record.presentCount < record.totalCount) {
            return 'background-color: #ffcfcf;' // red, border: 1px solid green;
          } else {
            return 'background-color: #ceffce;' // green
          }
        }
      }
      return ''
    },
    getTdStyle: function (col) {
      if (col.name === 'tools') {
        return 'padding: 0 !important; margin: 0;'
      }
      return ''
    },
    getToolStyle: function (tool) {
      if (tool.controlResult != null) {
        if (tool.controlResult === 'present') {
          return 'background-color: #ceffce;' // green
        } else if (tool.controlResult === 'absent') {
          return 'background-color: #ffcfcf;' // red, border: 1px solid green;
        }
      }
      return ''
    }
  }
}

